/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Badge, Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, BadgeOutlined, Flag, Google} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {useEffect, useState} from "react";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {ESTADOSUSUARIOS} from "../../Constantes";
import IngresoCheckGrupo from "../../Modulo_formularios/Componentes/IngresoCheckGrupo";

const Formulario_Adminstradores = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoImagenCrop dato={'img'} {...props} ancho={2} alto={1}/>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={Flag} nombre={'Estado'} dato={'estado'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={ESTADOSUSUARIOS.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Tipo'} dato={'tipo'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={Google} nombre={'Correo de Google'} dato={'correo'} {...props}
                    />
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Adminstradores